import { render, staticRenderFns } from "./AnnouncementTime.vue?vue&type=template&id=75bcb97a&scoped=true"
import script from "./AnnouncementTime.vue?vue&type=script&lang=js"
export * from "./AnnouncementTime.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementTime.vue?vue&type=style&index=0&id=75bcb97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bcb97a",
  null
  
)

export default component.exports